// src/config/wsAccountConfig.js

// Application endpoints (prefixes /app)
export const WS_ACCOUNT_APP_ENDPOINT_BASE = '/account';
export const WS_ACCOUNT_TOPICS = { // This is for the /app/* part
    GET_STATE: '/get-state',
    UPGRADE: '/upgrade',
    EXTEND: '/extend',
    CANCEL: '/cancel',
    INITIATE_PAYMENT: '/initiate-payment', // <-- NEW TOPIC for APP endpoint
};

// Message types (used in the 'type' field of WebSocketMessage from backend)
export const WS_ACCOUNT_TYPES = {
    STATE: 'ACCOUNT_STATE',
    ACTION_INITIATED: 'ACCOUNT_ACTION_INITIATED', // User action (upgrade, extend) acknowledged, payment method selection may be next
    PAYMENT_URL_READY: 'ACCOUNT_PAYMENT_URL_READY', // Sent by backend when payment URL is generated
    ACTION_SUCCESS: 'ACCOUNT_ACTION_SUCCESS',     // Action (upgrade, cancel, payment) completed successfully
    ACTION_FAILED: 'ACCOUNT_ACTION_FAILED',       // Action failed
    // ... any other specific types you might have
};


// User-specific queue destinations (subscribed by client)
// Base for user-specific queues. Spring prepends /user for user-specific routing.
// Frontend subscription path uses /queue/...
export const WS_ACCOUNT_USER_QUEUE_BASE = '/user/queue/account'; // <-- Corrected: Added /user prefix
export const WS_ACCOUNT_USER_TOPICS = { // These are appended to the base above for subscription
    STATE: '/state',   // For full state updates
    STATUS: '/status', // For action statuses, progress, payment URLs
    ERROR: '/error',   // For errors related to account actions
};

// Helper to construct full app endpoint path for sending messages
export const getAccountAppEndpoint = (topic) => `${WS_ACCOUNT_APP_ENDPOINT_BASE}${topic}`;

// Helper to construct full user queue topic path for subscription
export const getAccountUserQueueTopic = (topicSuffix) => `${WS_ACCOUNT_USER_QUEUE_BASE}${topicSuffix}`;


// Example usage for sending:
// sendMessage(getAccountAppEndpoint(WS_ACCOUNT_TOPICS.UPGRADE), { planId: 'premium' });

// Example usage for subscribing:
// subscribe(getAccountUserQueueTopic(WS_ACCOUNT_USER_TOPICS.STATUS), handleStatusUpdate);